import {useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {getAllWelcomeLinks} from './settingsSlice'

export const useWelcomeLinks = () => {
	const dispatch = useDispatch()
	const {status,client,trainer} = useSelector(state=>state.settings.welcomeLinks)
	if(status === 'init'){
		dispatch(getAllWelcomeLinks())
	}
	return {status,client,trainer}
}

export const useDefaultCurrency = ()=>{
	const acceptedCurrencyId = useSelector(state=>state.settings.acceptedCurrencyId)
	const acceptedCurrency = useSelector(state=>state.settings.acceptedCurrencies.entities[acceptedCurrencyId])
	return acceptedCurrency
}